import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { langList } from '@/lang';
import { utilCookies } from '@/util/cookies';
export default {
  data: function data() {
    return {
      langList: langList,
      currentLang: '',
      title: 'Flash HR'
    };
  },
  computed: {
    isShowLogout: function isShowLogout() {
      return this.$route.name === 'loginCompany' || this.$route.name === 'loginWarning' || this.$route.name === 'create-company' || this.$route.name === 'resetPass';
    }
  },
  created: function created() {
    var _this = this;
    var lang = utilCookies.getLanguage() || localStorage.getItem('language');
    this.langList.forEach(function (item) {
      if (item.key === lang) _this.currentLang = item.label;
    });
  },
  methods: {
    changeLang: function changeLang(item) {
      utilCookies.setLanguage(item.key);
      localStorage.setItem('language', item.key);
      window.location.reload();
    },
    // 划过下载APP添加埋点
    show: function show() {
      if (['/login/index', '/login/loginCompany'].includes(this.$route.path)) {
        // 选择公司页面埋点
        this.$ga.event('FHRLogin', 'click', 'AppDownload', 7);
      } else {
        // 创建新公司页面埋点
        this.$ga.event('FHRSignup', 'click', 'AppDownload', 7);
      }
    },
    logout: function logout() {
      var _this2 = this;
      // 退出登录埋点
      if (this.$route.path === '/login/create-company') {
        // 创建新公司页面埋点
        this.$ga.event('FHRCreateCompany', 'click', 'Logout', 24);
      } else {
        // 选择公司页面埋点
        this.$ga.event('FHRSelectCompany', 'click', 'Logout', 16);
      }
      this.$confirm(this.$t('301'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        // this.$s.clear()
        utilCookies.clear();
        _this2.$router.replace('/', function () {
          return window.location.reload();
        });
      });
    }
  }
};